export const tokenManager = {
  getToken: () => sessionStorage.getItem("authToken") || localStorage.getItem("authToken"),
  setToken: (token) => {
    sessionStorage.setItem("authToken", token);
    localStorage.setItem("authToken", token);
  },
  removeToken: () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("token");
    localStorage.removeItem("authToken");
    localStorage.removeItem("token");
  }
};
